/* FrameDex — facets.js
   Collection filtering + sorting. Submits the filter form via Ajax, updates
   the product grid and URL. Degrades to a normal form submit without JS. */
(function () {
  'use strict';

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('input', (e) => {
        if (e.target.matches('input[type="checkbox"], input[type="radio"], select')) {
          this.debouncedApply();
        }
      });
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.apply(); });
      this.debouncedApply = this.debounce(() => this.apply(), 400);

      document.addEventListener('click', (e) => {
        const clear = e.target.closest('[data-facet-remove]');
        if (clear) { e.preventDefault(); this.applyURL(clear.getAttribute('href')); }
      });

      // Mobile drawer toggle
      this.drawer = this.querySelector('[data-facet-drawer]');
      const open = document.querySelector('[data-facet-open]');
      const close = this.querySelector('[data-facet-close]');
      if (open && this.drawer) open.addEventListener('click', () => this.toggleDrawer(true));
      if (close && this.drawer) close.addEventListener('click', () => this.toggleDrawer(false));
    }

    toggleDrawer(state) {
      if (!this.drawer) return;
      this.drawer.toggleAttribute('open', state);
      document.body.classList.toggle('drawer-open', state);
    }

    debounce(fn, wait) {
      let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); };
    }

    apply() {
      const params = new URLSearchParams(new FormData(this.form)).toString();
      const url = `${window.location.pathname}?${params}`;
      this.applyURL(url);
    }

    async applyURL(url) {
      this.setAttribute('aria-busy', 'true');
      try {
        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        ['[data-product-grid]', '[data-active-facets]', '[data-facet-controls]', '[data-collection-count]'].forEach((sel) => {
          const incoming = doc.querySelector(sel);
          const current = this.ownerDocument.querySelector(sel);
          if (incoming && current) {
            current.innerHTML = incoming.innerHTML;
            // Cards injected here bypass the boot-time [data-reveal] observer,
            // so reveal them explicitly to avoid them staying at opacity:0.
            current.querySelectorAll('[data-reveal]').forEach((n) => n.classList.add('is-visible'));
          }
        });
        window.history.pushState({ url }, '', url);
        const grid = document.querySelector('[data-product-grid]');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        window.location.href = url;
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }
  if (!customElements.get('facet-filters')) customElements.define('facet-filters', FacetFilters);

  window.addEventListener('popstate', (e) => {
    if (e.state && e.state.url) window.location.href = e.state.url;
  });
})();
